// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class IAuthenticateAndCreateSessionRequest {
    static getAttributeTypeMap() {
        return IAuthenticateAndCreateSessionRequest.attributeTypeMap;
    }
}
IAuthenticateAndCreateSessionRequest.discriminator = undefined;
IAuthenticateAndCreateSessionRequest.attributeTypeMap = [
    {
        "name": "key",
        "baseName": "key",
        "type": "string"
    },
    {
        "name": "username",
        "baseName": "username",
        "type": "string"
    },
    {
        "name": "password",
        "baseName": "password",
        "type": "string"
    }
];
//# sourceMappingURL=iAuthenticateAndCreateSessionRequest.js.map